/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { CallState, isLoadedOrInError, LoadingState } from '@elio/shared/models';
import { filter, first, map, ObservableInput, pipe, takeUntil } from 'rxjs';

export const filterNullUndefined = <T>() =>
  pipe(filter((value: T): value is NonNullable<T> => value !== undefined && value !== null));

/** Emit only the first not null nor undefined value. An unsubscribe subject must be set to avoid the case if none value pass through the filter and then the observable never completes */
export const firstNotNullUndefinedUntil = <T>(unsubscribeSubject: ObservableInput<void>) =>
  pipe(filterNullUndefined<T>(), first(), takeUntil(unsubscribeSubject));

/**
 * Reject arrays containing at least one null or undefined value.
 */
export const filterArrayContainNullUndefined = () =>
  pipe(filter((values: any[]) => values.reduce((acc, value) => acc && value !== undefined && value !== null)));

export const filterStatus = (loadingState: LoadingState) =>
  pipe(filter((status: CallState) => status === loadingState));

export const filterStatusLoadedOrInError = () => pipe(filter((status: CallState) => isLoadedOrInError(status)));

/**
 * Reject empty arrays.
 */
export const filterEmptyArray = <T>() => pipe(filter((values: T) => Array.isArray(values) && values.length > 0));

export const filterEmpty = <T>() => pipe(filter((value: T) => value !== ''));

export const filterNullUndefinedOrZero = <T>() =>
  pipe(filter((value: T): value is NonNullable<T> => value !== undefined && value !== null && value !== 0));

export const mapUndefinedToEmptyArray = <T>() =>
  pipe(
    map((value: T[] | undefined): T[] => {
      if (value === undefined) {
        return [];
      }
      return value;
    })
  );
